import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { HubConfigRolesDrawerComponent } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-drawer/hub-config-roles-drawer.component';

import { HubConfigRolesDrawerData } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-drawer/hub-config-roles-drawer-data';

@Injectable({
  providedIn: 'root',
})
export class HubConfigRolesDrawerService {
  constructor(private readonly drawerService: NzDrawerService) {}

  openDrawer(data: HubConfigRolesDrawerData) {
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzContent: HubConfigRolesDrawerComponent,
      nzData: { data },
      nzTitle: data.role?.name
        ? $localize`:@@hubConfigRolesDialog.editRoleTitle: Edit role`
        : $localize`:@@hubConfigRolesDialog.addRoletitle: Add new role`,
      nzWidth: '600px',
    }).afterClose;
  }
}
